/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Source_LabelInputs */



/**
* | output |
* | --- |
* | "Media Source" |
*
* @param {New_Project_Media_Source_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_source_label = /** @type {((inputs?: New_Project_Media_Source_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Source_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Source media")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienquelle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fonte multimediale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Источник информации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fuente de medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体来源")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアソース")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया स्रोत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fonte de mídia")
	return /** @type {LocalizedString} */ ("Media Source")
});